import React from 'react';

interface LockIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    color?: string;
}

const LockIcon = ({
    size = 24,
    color = 'black',
    ...props
}: LockIconProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 2C13.5524 1.99994 15.0444 2.60157 16.1625 3.67847C17.2806 4.75537 17.9378 6.22371 17.996 7.775L18 8H19C19.5046 7.99984 19.9906 8.19041 20.3605 8.5335C20.7305 8.87659 20.9572 9.34685 20.995 9.85L21 10V20C21.0002 20.5046 20.8096 20.9906 20.4665 21.3605C20.1234 21.7305 19.6532 21.9572 19.15 21.995L19 22H5C4.49542 22.0002 4.00943 21.8096 3.63945 21.4665C3.26947 21.1234 3.04284 20.6532 3.005 20.15L3 20V10C2.99984 9.49542 3.19041 9.00943 3.5335 8.63945C3.87659 8.26947 4.34684 8.04284 4.85 8.005L5 8H6C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2ZM19 10H5V20H19V10ZM12 12C12.4266 12.0001 12.842 12.1367 13.1854 12.3896C13.5289 12.6426 13.7825 12.9988 13.9092 13.4062C14.0358 13.8135 14.0289 14.2507 13.8895 14.6538C13.75 15.057 13.4853 15.405 13.134 15.647L13 15.732V17C12.9997 17.2549 12.9021 17.5 12.7272 17.6854C12.5522 17.8707 12.313 17.9822 12.0586 17.9972C11.8042 18.0121 11.5536 17.9293 11.3582 17.7657C11.1627 17.6021 11.0371 17.3701 11.007 17.117L11 17V15.732C10.6187 15.5119 10.3208 15.1721 10.1523 14.7653C9.98384 14.3586 9.95429 13.9076 10.0682 13.4824C10.1822 13.0571 10.4333 12.6813 10.7825 12.4133C11.1318 12.1453 11.5597 12 12 12ZM12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8H16C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4Z"
            fill={color}
        />
    </svg>
);

export default LockIcon;
